import { Link } from 'react-router-dom';
import { ROUTES } from '@/routes.ts';
import styles from './CapacityIndicator.module.css';

interface Props {
  /** Consultations currently occupying one of the doctor's parallel-consult slots. */
  occupied: number;
  /** The doctor's max_parallel_consultations cap. Undefined while still loading. */
  max: number | undefined;
  className?: string;
}

export function CapacityIndicator({ occupied, max, className }: Props) {
  const pct = max ? Math.min(100, (occupied / max) * 100) : 0;
  const isFull = max != null && occupied >= max;

  return (
    <Link
      to={ROUTES.doctorProfile}
      className={className ? `${styles.capacity} ${className}` : styles.capacity}
      title="Limiet aanpassen in profiel"
    >
      <h1 className={styles.label}>{max != null ? `${occupied} van ${max} consultaties` : 'Consultaties'}</h1>
      {max != null && (
        <div
          className={styles.track}
          role="progressbar"
          aria-valuenow={occupied}
          aria-valuemin={0}
          aria-valuemax={max}
          aria-label="Bezette consultatie-slots"
        >
          <div className={`${styles.fill}${isFull ? ` ${styles.fillFull}` : ''}`} style={{ width: `${pct}%` }} />
        </div>
      )}
    </Link>
  );
}
